//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const moment = require("moment-timezone");
import {
  server,
  imagemasterPTUrl,
  filemasterPTUrl,
} from "@/services/constants";
import api from "@/services/api";
import SuccessDialog from "@/components/cards/SuccessDialog";
import SuccessDialogPush from "@/components/cards/SuccessDialogPush";
import pdfvuer from "pdfvuer";

export default {
  name: "MasterPatentAdd",
  components: { SuccessDialog, SuccessDialogPush, pdf: pdfvuer },
  data() {
    return {
      sendBilling: "Reply All",
      sendBillingList: ["Reply All", "Specific Email", "Link"],
      sendBillingDetail: "",
      customer_list: [],
      customer_selected: null,
      customer_address: "",

      removed_cer_files: [],
      fileindex_cer: -1,
      preview_list_cer: [],
      image_list_cer: [],
      filename_cer: [],
      getpreview_list_cer: [],
      preview_list2_cer: [],
      checkfileeadd_cer: false,
      dialogDelete_cer: false,

      owner_contact_list: [],
      owner_address: "",
      associate_address: "",
      agent_address: "",
      priorityListOld: [],
      priorityList: [
        {
          id: 0,
          number: "",
          date: "",
          country: "",
          menu: false,
        },
      ],

      other_sub: "",
      subtype_list: ["PARIS", "PCT", "Other"],
      showtimelineData: [],
      timelineData: [
        // { id: 1, event: "Start Project", date: "18/06/2025" },
        // { id: 2, event: "Design Phase", date: "19/06/2025"},
        // { id: 3, event: "Development Phase", date: "23/06/2025"},
        // { id: 4, event: "Testing", date: "28/06/2025"},
        // { id: 5, event: "Deployment", date: "03/07/2025"},
      ],
      preview_list2: [],
      mDataArrayappointment: [],
      hideshowlistofrecord: false,
      disablebtnappointmenttimeline: false,
      disablebtnappointmentallrecord: false,
      getpreview_list: [],
      image: null,
      previewimage: null,
      previewimageedit: null,
      image_list: [],
      preview_list: [],
      dialogpreviewimage: false,
      checkfileapreview: false,
      previewpopupfile: [],
      previewpopupfile2: [],
      dialogpreviewfile: false,
      dialogDelete: false,
      dialogDeleteimage: false,
      filename: [],
      oldfilename: [],
      imagename: "",
      load_bg: false,
      checkfileadd: false,
      checkimageadd: false,
      filenameedit: [],
      imagenameedit: "",
      getcurrentimage: "",
      getoldimage: "",
      getcurrentfilename: [],
      getoldfilename: [],
      oldpdffiles: [],
      fileindex: -1,
      checkfileedit: false,
      checkimageedit: false,
      page: 1,
      numPages: 0,
      numPagespreview: 0,
      pdfdata: undefined,
      errors: [],
      scale: "page-width",
      dialogEditmastertm: false,
      image_listedit: [],
      getpreview_listedit: [],
      preview_listedit: [],
      preview_listedit2: [],

      country_list: [],
      isShowPassword: false,
      fullPage: true,
      objecttype_list: [],
      contact_owner_list: [],
      contact_agent_list: [],
      contact_associate_list: [],
      menuadd: false,
      menuaddAppD: false,
      menuaddptd: false,
      menuaddpubd: false,
      menuadderdd: false,
      menuaddeaxmd: false,
      menuadderd: false,
      menuaddlapd: false,
      menuaddnad: false,
      menuaddnadfinalDatePayment: false,
      menuaddnrd: false,
      menuaddlra: false,
      menuaddndd: false,
      text_color: "text-h5 green--text text-center",
      title: "green",
      message: "green",
      link: "",
      dialogAdd: false,
      main_id: 0,
      mode_operation: "Create",
      date_of_application: null,
      date_of_patent: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      date_of_publishing: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      exam_request_date: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      exam_request_deadline: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      date_of_examination: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      next_deadline: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      last_annuity_paid: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      next_annuity_date: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      final_due_date_for_next_payment: null,
      next_renewal: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      last_renewal_att: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      type_list: [
        { type_name: "Design", type_number: "1" },
        { type_name: "Invention", type_number: "2" },
        { type_name: "Petty", type_number: "3" },
      ],
      // eslint-disable-next-line prettier/prettier
      latest_list: [
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
      ],
      menuInterNew: false,
      international_filing_date: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      patent_status_list: [
        {
          patent_status_name: "Nil (Unrecognised Status)",
          patent_status_id: 1,
        },
        { patent_status_name: "Pending", patent_status_id: 2 },
        { patent_status_name: "Registered", patent_status_id: 3 },
        { patent_status_name: "Renewal Pending", patent_status_id: 5 },
        { patent_status_name: "Closed", patent_status_id: 6 },
      ],
      itemdata: {
        international_filing_number: "",
        international_filing_date: null,
        tm_type: 0,
        file_no: "",
        title: "",
        name_of_client: "",
        app_no: "",
        patent_no: "",
        city: "",
        owner_contact: 0,
        agent_contact: 0,
        associate_contact: 0,
        val_no: "",
        page_no: "",
        priority_number: "",
        status: 0,
        type: "",
        sub_type: "",
        remark: "",
        dead_last_annuity_paid: "",
        client_ref: "",
        good_service: "",
        registration_condition: "",
        owner_address: "",
        agent_address: "",
        associate_address: "",
        date_of_patent: null,
        date_of_application: null,
        date_of_publishing: null,
        date_of_examination: null,
        next_renewal: null,
        last_renewal_att: null,
        next_deadline: null,
        exam_request_deadline: null,
        exam_request_date: null,
        next_annuity_date: null,
        final_due_date_for_next_payment: null,
        last_annuity_paid: null,
      },
      headers: [
        {
          text: "Work Type",
          align: "left",
          // sortable: false,
          value: "documenttype_code",
          width: "10%",
          divider: true,
        },
        // {
        //   text: "Doc Type",
        //   align: "left",
        //   // sortable: false,
        //   value: "documenttype_actions_showdata",
        //   width: "10%",
        //   divider: true,
        // },
        {
          text: "File No.",
          align: "left",
          // sortable: false,
          value: "refno",
          divider: true,
        },

        // { text: "Date Create", value: "show_date", divider: true },
        { text: "Application No.", value: "app_no", divider: true },
        { text: "Client Name", value: "trademark_name", divider: true },
        { text: "Receive Date", value: "receive_date_show", divider: true },
        { text: "Deadline Date", value: "dead_line", divider: true },
        { text: "Last Update By", value: "display_name", divider: true },
        // { text: "Page No", value: "", divider: true },
        // { text: "Version", value: "", divider: true },
        // { text: "Lawyer", value: "lower", divider: true },
        { text: "Status", value: "show_status", divider: true },
        {
          text: "",
          value: "actions",
          width: "15%",
          align: "center",
          divider: true,
        },
      ],
      headersFile: [
        {
          text: "File",
          align: "left",
          // sortable: false,
          value: "file_name",
          divider: true,
        },
        {
          text: "Date Upload",
          align: "left",
          value: "update_date",
          divider: true,
        },
      ],
      FlieArray: [],
      dialogTimeline: false,
      disabled_status: false,
    };
  },
  async mounted() {
    await this.loadCustomerComboboxMetter();
    await this.loaddataobjecttypeBygroupId();
    await this.loaddatacontactByContact_type_owner();
    await this.loaddatacontactByContact_type_agent();
    await this.loaddatacontactByContact_type_associate();
    await this.loaddatacountry();
    await this.loaddata();
    await this.loaddataPriority();
    await this.loadshowTimeline();
    await this.loadfilecer();
    this.$hideLoader();
  },
  methods: {
    // เปิดไฟล์เก่าจาก server ถ้าไม่พบไฟล์ให้แจ้งเตือนแทน
    // เปิดไฟล์เก่าจาก server (เปิดตรง ไม่ fetch เช็คก่อน เพื่อเลี่ยง CORS)
    openOldFile(url) {
      const tab = window.open(url, "_blank");
      if (!tab) {
        // กรณี browser block popup
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "เปิดไฟล์ไม่ได้",
          "Browser บล็อก popup กรุณาอนุญาต popup สำหรับเว็บนี้",
          "text-h5 red--text text-center"
        );
      }
    },
    // แปลงค่า JSON เป็น array แบบปลอดภัย (รองรับ "", null, string, array)
    safeParseArray(value) {
      if (Array.isArray(value)) return value;
      if (!value || typeof value !== "string") return [];
      try {
        const parsed = JSON.parse(value);
        return Array.isArray(parsed) ? parsed : [];
      } catch (e) {
        return [];
      }
    },

    //onChanege customer filter full_address by id
    async onSelectComboboxMetterChange(value) {
      // console.log(`onSelectComboboxMetterChange: ${value}`);
      // console.log(`customer_list:${JSON.stringify(this.customer_list)}`);

      const selectedCustomer = this.customer_list.find(
        (customer) => customer.id === value
      );
      this.customer_address = selectedCustomer
        ? selectedCustomer.full_address
        : "";
    },
    async loadCustomerComboboxMetter() {
      const result = await api.getCustomerComboboxByMetter(
        localStorage.getItem(server.COMPANYID)
      );
      // console.log(`loadCustomerComboboxMetter: ${JSON.stringify(result.data)}`);

      this.customer_list = result.data;
    },
    editItemtimeline(item) {
      const url = `/appointment-patent-edit/${item.appointment_id}`; // หรือใส่ query ?file_no=xxx
      window.open(url, "_blank"); // เปิดหน้าใหม่
    },
    async loadfilecer() {
      try {
        const data_search = {
          tbl_name: "masterpt_cer",
          tbl_id: Number(this.main_id),
        };

        const res_cer = await api.getAllFileAtLawFile({ params: data_search });

        this.filename_cer = [];
        this.image_list_cer = [];
        this.getpreview_list_cer = [];
        this.preview_list_cer = [];
        this.removed_cer_files = []; // <<<< ประกาศไว้ตั้งต้น

        for (const file of res_cer.data) {
          this.filename_cer.push({
            name: file.file_name,
            checktypefile: "oldfile",
            id: file.id,
            update_date: file.update_date,
          });

          const fileUrl = `${filemasterPTUrl}/${this.$route.params.masterpt_id}/${file.file_name}`;
          this.image_list_cer.push({
            name: file.file_name,
            url: fileUrl,
            id: file.id,
            checktypefile: "oldfile",
          });
        }

        this.preview_list2_cer = this.preview_list_cer;
        this.checkfileeadd_cer = true;
      } catch (err) {
        console.error("Error loading cer files:", err);
      }
    },
    generateUniqueFileName(originalName) {
      let newName = originalName;
      let nameIndex = 1;

      // รวมชื่อไฟล์ทั้งหมด
      const currentNames = [
        ...this.filename.map((f) => (typeof f === "string" ? f : f.name)),
        ...this.filename_cer.map((f) => (typeof f === "string" ? f : f.name)),
        ...this.filenameedit.map((f) => (typeof f === "string" ? f : f.name)),
      ];

      // ถ้าชื่อซ้ำให้เพิ่ม _1 _2 ...
      while (currentNames.includes(newName)) {
        const dotIndex = originalName.lastIndexOf(".");
        if (dotIndex !== -1) {
          newName = `${originalName.substring(
            0,
            dotIndex
          )}-${nameIndex}${originalName.substring(dotIndex)}`;
        } else {
          newName = `${originalName}-${nameIndex}`;
        }
        nameIndex++;
      }

      return newName;
    },

    async previewMultiImageEdit(event) {
      var getnamedata = [];
      this.filenameedit = [];
      var input = event.target;
      var count = input.files.length;
      var index = 0;
      if (input.files) {
        while (count--) {
          var reader = new FileReader();
          reader.onload = (e) => {
            this.getpreview_listedit.push(e.target.result);
            this.preview_listedit.push(e.target.result);
          };
          if (input.files[index].type === "application/pdf") {
            getnamedata.push(input.files[index]);
            reader.readAsDataURL(input.files[index]);
          }
          index++;
        }
      }

      await this.getPdf(this.getpreview_listedit, "newfile");
      this.preview_listedit2 = this.preview_listedit;

      getnamedata.forEach((x) => {
        let originalName = x.name;
        let name = originalName;
        let counter = 1;

        const existingNames = [
          ...this.filename.map((f) => f.name),
          ...this.filenameedit,
          ...this.filename_cer.map((f) => f.name), // เพิ่มเช็คชื่อไฟล์ cer ด้วย
        ];

        while (existingNames.includes(name)) {
          const dotIndex = originalName.lastIndexOf(".");
          if (dotIndex !== -1) {
            const basename = originalName.substring(0, dotIndex);
            const extension = originalName.substring(dotIndex);
            name = `${basename}-${counter}${extension}`;
          } else {
            name = `${originalName}-${counter}`;
          }
          counter++;
        }

        this.filename.push({ name: name, checktypefile: "newfile" });
        this.filenameedit.push(name);

        const renamedFile = new File([x], name, { type: x.type });
        this.image_listedit.push(renamedFile);
      });

      this.checkfileedit = true;
    },

    async previewMultiImage_cer(event) {
      var input_cer = event.target;
      var count_cer = input_cer.files.length;
      var index_cer = 0;

      if (input_cer.files) {
        while (count_cer--) {
          var reader_cer = new FileReader();
          reader_cer.onload = (e) => {
            this.getpreview_list_cer.push(e.target.result);
            this.preview_list_cer.push(e.target.result);
          };

          if (input_cer.files[index_cer].type === "application/pdf") {
            let originalFile = input_cer.files[index_cer];
            let newName = this.generateUniqueFileName(originalFile.name);

            let renamedFile = new File([originalFile], newName, {
              type: originalFile.type,
            });

            this.image_list_cer.push(renamedFile);
            this.filename_cer.push({ name: newName, checktypefile: "newfile" });

            reader_cer.readAsDataURL(renamedFile);
          }
          index_cer++;
        }
      }

      await this.getPdfforAdd_cer(this.getpreview_list_cer);
      this.preview_list2_cer = this.preview_list_cer;
      this.checkfileeadd_cer = true;
    },

    async popupdeletefile_cer(index) {
      this.fileindex_cer = index;
      this.dialogDelete_cer = true;
    },
    async closeDelete_cer() {
      this.fileindex_cer = -1;
      this.dialogDelete_cer = false;
    },
    async deleteItemConfirm_cer() {
      // กัน error
      if (this.fileindex_cer < 0) return;

      // --- เก็บชื่อไฟล์ที่จะลบ ---
      const removedFileName = this.filename_cer[this.fileindex_cer]?.name;
      if (
        removedFileName &&
        !this.removed_cer_files.includes(removedFileName)
      ) {
        this.removed_cer_files.push(removedFileName);
      }

      // --- ลบออกจากทุก list ---
      this.preview_list2_cer = [];
      this.getpreview_list_cer.splice(this.fileindex_cer, 1);
      this.image_list_cer.splice(this.fileindex_cer, 1);
      this.filename_cer.splice(this.fileindex_cer, 1);

      // --- รีโหลด PDF preview ---
      await this.getPdfforAdd_cer(this.getpreview_list_cer);

      this.preview_list2_cer = this.preview_list_cer;
      this.fileindex_cer = -1;
      this.dialogDelete_cer = false;
    },
    async popuppreviewfile_cer(fileindex) {
      this.previewpopupfile2 = [];

      // ถ้าไฟล์ index นี้เป็นไฟล์ใหม่ (ใน getpreview_list_cer)
      if (
        fileindex >=
        this.filename_cer.filter((f) => f.checktypefile === "oldfile").length
      ) {
        // คำนวณ index สำหรับไฟล์ใหม่ (เอา index ไฟล์เก่าออก)
        const indexNew =
          fileindex -
          this.filename_cer.filter((f) => f.checktypefile === "oldfile").length;

        let pdf_newTab = window.open("");
        pdf_newTab.document.write(
          `<html><head><title>pdf file</title></head><body><iframe title="MY title" width="100%" height="100%" src="${this.getpreview_list_cer[indexNew]}"></iframe></body></html>`
        );

        return;
      } else {
        // ไฟล์เก่า ใช้ url จาก image_list_cer ที่เก็บไว้
        const oldFiles = this.filename_cer.filter(
          (f) => f.checktypefile === "oldfile"
        );
        const fileName = oldFiles[fileindex].name;

        let pdf_newTab = window.open(
          `${filemasterPTUrl}/${this.$route.params.masterpt_id}/${fileName}`
        );

        return;
      }
    },
    async getPdfforAdd_cer(item_cer) {
      this.preview_list_cer = [];
      let getfile_cer = [];
      getfile_cer = item_cer;
      getfile_cer.forEach((file_cer, index_cer) => {
        this.preview_list_cer.push(pdfvuer.createLoadingTask(`${file_cer}`));
      });
      this.preview_list_cer.forEach((item_cer, index_cer) => {
        item_cer.then((pdf_cer) => {
          this.numPages_cer = pdf_cer.numPages;
          function changePage_cer() {
            var i_cer = 1,
              count_cer = Number(pdf_cer.numPages);
            do {
              if (
                window.pageYOffset >=
                this.findPos(document.getElementById(i_cer)) &&
                window.pageYOffset <=
                this.findPos(document.getElementById(i_cer + 1))
              ) {
                this.page_cer = i_cer;
              }
              i_cer++;
            } while (i_cer < count_cer);
            if (
              window.pageYOffset >= this.findPos(document.getElementById(i_cer))
            ) {
              this.page_cer = i_cer;
            }
          }
        }).catch((err) => {
          console.warn("Load PDF failed:", err && err.message);
        });
      });
      this.checkfileadd_cer = true;
    },
    onApplicationDateChanged() {
      if (this.date_of_application) {
        if (
          this.itemdata.dead_last_annuity_paid != "" &&
          this.itemdata.dead_last_annuity_paid
        ) {
          const parts = this.date_of_application.split("-");
          const date = new Date(+parts[0], parts[1] - 1, +parts[2]);

          const yearsToAdd = Number(this.itemdata.dead_last_annuity_paid) - 1;

          const originalDay = date.getDate();
          date.setFullYear(date.getFullYear() + yearsToAdd);

          if (date.getDate() < originalDay) {
            date.setDate(0);
          }

          const y = date.getFullYear();
          const m = String(date.getMonth() + 1).padStart(2, "0");
          const d = String(date.getDate()).padStart(2, "0");

          this.itemdata.next_annuity_date = `${d}/${m}/${y}`;
          this.next_annuity_date = `${y}-${m}-${d}`;

          this.updateFinalDueDateFromNextAnnuity();
        }
      }
    },
    updateNextPaymentDueDate() { },
    updateFinalDueDateFromNextAnnuity() {
      var dateString = this.next_annuity_date;

      if (!dateString) return "";

      const [year, month, day] = dateString.split("-").map(Number);
      const date = new Date(year, month - 1, day); // สร้าง Date

      date.setDate(date.getDate() + 60); // บวก 60 วัน

      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, "0");
      const d = String(date.getDate()).padStart(2, "0");

      this.itemdata.final_due_date_for_next_payment = `${d}/${m}/${y}`;
    },
    addPriority() {
      this.priorityList.push({
        id: 0,
        number: "",
        date: "",
        country: "",
        menu: false,
      });
    },

    removePriority(index) {
      this.priorityList.splice(index, 1);
    },
    formatDatePriority(date) {
      if (!date) return "";
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDateInputPriority(value) {
      if (!value) return "";
      const parts = value.split("/");
      if (parts.length === 3) {
        return `${parts[2]}-${parts[1]}-${parts[0]}`;
      }
      return value; // fallback ถ้า format ไม่ถูกต้อง
    },
    openTimeline() {
      this.dialogTimeline = true;
    },
    async popupdeletefile(index) {
      this.fileindex = index;
      this.dialogDelete = true;
    },
    async closeDelete() {
      this.fileindex = -1;
      this.dialogDelete = false;
    },
    async deleteItemConfirm() {
      // this.preview_listedit = [];
      this.filename.splice(this.fileindex, 1);
      this.preview_listedit2 = [];
      let index = this.fileindex - this.oldpdffiles.length;
      if (this.fileindex >= this.oldpdffiles.length) {
        this.getpreview_listedit.splice(index, 1);
        this.image_listedit.splice(index, 1);
        this.filenameedit.splice(index, 1);
      } else {
        this.getoldfilename.push(this.oldpdffiles[this.fileindex]);
        this.oldpdffiles.splice(this.fileindex, 1);
        this.getcurrentfilename = this.oldpdffiles;

        // await this.getPdf(this.oldpdffiles[fileindex], "oldfile");
      }

      await this.getPdf(this.getpreview_listedit, "newfile");

      this.preview_listedit2 = this.preview_listedit;
      this.fileindex = -1;
      this.dialogDelete = false;
    },
    async popupdeleteimage() {
      this.dialogDeleteimage = true;
    },
    async closeDeleteimage() {
      this.dialogDeleteimage = false;
    },
    async deleteItemConfirmimage() {
      this.checkimageedit = false;

      this.getoldimage = this.getcurrentimage;
      // this.getcurrentimage = "";
      this.previewimageedit = "";
      this.imageedit = null;
      this.imagenameedit = "";
      this.dialogDeleteimage = false;
    },
    async popuppreviewfile(fileindex) {
      this.previewpopupfile2 = [];

      let index = fileindex - this.oldpdffiles.length;
      if (fileindex >= this.oldpdffiles.length) {
        let pdf_newTab = window.open("");
        pdf_newTab.document.write(
          "<html><head><title>pdf file</title></head><body><iframe title='MY title'  width='100%' height='100%' src='" +
          this.getpreview_listedit[index] +
          "'></iframe></body></html>"
        );

        return;
        await this.getPdfforpreview(this.getpreview_listedit[index], "newfile");
      } else {
        await this.openOldFile(
          `${filemasterPTUrl}/${this.$route.params.masterpt_id}/${this.oldpdffiles[fileindex]}`
        );

        return;
      }
    },
    async closepreviewfile() {
      this.dialogpreviewfile = false;
    },
    async popuppreviewimage() {
      const imageTab = window.open("");
      imageTab.document.write(`
        <html>
          <head>
            <title>Preview Image</title>
          </head>
          <body style="margin:0; display:flex; flex-direction:column; justify-content:center; align-items:center; height:100vh; background-color:#000;">
            <img src="${this.previewimageedit}" alt="Preview" style="max-width:100%; max-height:100%; margin-bottom:20px;" />
          </body>
        </html>
      `);
      return;
    },
    async closepreviewimage() {
      this.dialogpreviewimage = false;
    },
    previewImageEdit: function (event) {
      var input = event.target;
      if (input.files) {
        var reader = new FileReader();
        reader.onload = (e) => {
          this.previewimageedit = e.target.result;
          this.checkimageedit = true;
        };
        this.imageedit = input.files[0];
        reader.readAsDataURL(input.files[0]);
      }
      this.getoldimage = this.getcurrentimage;
      this.imagenameedit = this.imageedit.name;
    },

    async getPdfforpreview(datafile, method) {
      this.previewpopupfile = [];
      let getfile = [];
      getfile = datafile;
      if (method == "oldfile") {
        this.previewpopupfile.push(
          pdfvuer.createLoadingTask(
            `${filemasterPTUrl}/${this.$route.params.masterpt_id}/${getfile}`
          )
        );
      } else {
        this.previewpopupfile.push(pdfvuer.createLoadingTask(`${getfile}`));
      }

      this.previewpopupfile.forEach((item, index) => {
        item.then((pdf) => {
          this.numPagespreview = pdf.numPages;
        }).catch((err) => {
          console.warn("Load PDF failed:", err && err.message);
        });
      });
    },
    handle_pdf_link: function (params) {
      // Scroll to the appropriate place on our page - the Y component of
      // params.destArray * (div height / ???), from the bottom of the page div
      var page = document.getElementById(String(params.pageNumber));
      page.scrollIntoView();
    },
    async getPdf(item, method) {
      this.preview_listedit = [];

      if (method == "newfile") {
        // โหลดเฉพาะไฟล์ใหม่ (data URL จากเครื่อง) ไม่ยิง request ไป server
        (item || []).forEach((file) => {
          const task = pdfvuer.createLoadingTask(`${file}`);
          task
            .then((pdf) => {
              this.numPages = pdf.numPages;
            })
            .catch((err) => {
              console.warn("Load PDF failed:", err && err.message);
            });
          this.preview_listedit.push(task);
        });
      } else {
        // ไฟล์เก่าไม่ต้อง preload เพราะตอนกดดูจะเปิดผ่าน openOldFile แทน
        this.checkfileedit = !(item == "" || item == null);
      }
    },
    findPos(obj) {
      return obj.offsetTop;
    },

    async loaddata() {
      if (this.$route.params.masterpt_id) {
        this.mode_operation = "Update";
        this.main_id = this.$route.params.masterpt_id;

        var data_search = {
          tbl_name: "masterpt",
          tbl_id: Number(this.main_id),
        };

        const result_file = await api.getAllFileAtLawFile({
          params: data_search,
        });

        var fileName = "";
        var imageName = "";

        if (result_file.data.length > 0) {
          this.FlieArray = result_file.data;
          for (const [index, item] of result_file.data.entries()) {
            if (item.file_type == "image") {
              if (imageName) imageName += `,`;
              imageName += item.file_name;
            } else {
              if (fileName) fileName += `,`;
              fileName += item.file_name;
            }
          }
        }

        const result = await api.getByIdMasterPT(this.main_id);

        if (result.data && result.data.length > 0) {
          if (result.data[0].master_images == "") {
            result.data[0].master_images = imageName;
          } else {
            let masterImages = result.data[0].master_images;
            // แยกค่าด้วยเครื่องหมายคอมม่า
            let imageArray = masterImages.split(",");

            // ตัดช่องว่างที่หน้าและหลังของแต่ละค่า
            imageArray = imageArray.map((image) => image.trim());

            // ถ้าคุณต้องการลบคอมม่าที่ท้ายสุด ถ้ามี
            if (imageArray[imageArray.length - 1] === "") {
              imageArray.pop(); // ลบค่าว่างที่เกิดจากคอมม่าที่ท้ายสุด
            }

            for (const [index, item] of imageArray.entries()) {
              var data_tableimage = {
                id: 0,
                tbl_name: "masterpt",
                tbl_id: this.main_id,
                file_type: "image",
                file_name: item,
                created_at: "",
                updated_at: "",
                update_date: "-",
              };
              this.FlieArray.push(data_tableimage);
            }

            if (imageName != "") {
              result.data[0].master_images =
                result.data[0].master_images + "," + imageName;
            }
          }
          if (result.data[0].master_files == "") {
            result.data[0].master_files = fileName;
          } else {
            let masterFile = result.data[0].master_files;
            // แยกค่าด้วยเครื่องหมายคอมม่า
            let fileArray = masterFile.split(",");

            // ตัดช่องว่างที่หน้าและหลังของแต่ละค่า
            fileArray = fileArray.map((image) => image.trim());

            // ถ้าคุณต้องการลบคอมม่าที่ท้ายสุด ถ้ามี
            if (fileArray[fileArray.length - 1] === "") {
              fileArray.pop(); // ลบค่าว่างที่เกิดจากคอมม่าที่ท้ายสุด
            }

            for (const [index, item] of fileArray.entries()) {
              var data_tablefile = {
                id: 0,
                tbl_name: "masterpt",
                tbl_id: this.main_id,
                file_type: "file",
                file_name: item,
                created_at: "",
                updated_at: "",
                update_date: "-",
              };
              this.FlieArray.push(data_tablefile);
            }

            if (fileName != "") {
              result.data[0].master_files =
                result.data[0].master_files + "," + fileName;
            }
          }

          const editItem = result.data;
          this.itemdata = editItem[0];
          this.itemdata.status = Number(editItem[0].status);

          const item = result.data[0];

          // load image //
          try {
            this.imagenameedit = item.master_images;
            this.filename = [];
            this.filenameedit = [];
            if (item.master_files == "" || item.master_files == null) {
              this.checkfileedit = false;
            } else {
              let getdata = item.master_files.split(",");
              getdata.forEach((x) => {
                this.filename.push({ name: x, checktypefile: "oldfile" });
              });
              this.oldfilename = this.filename;
              this.oldpdffiles = item.master_files.split(",");
              this.getcurrentfilename = this.oldpdffiles;

              await this.getPdf(this.oldpdffiles, "oldfile");
              this.preview_listedit2 = this.preview_listedit;
              this.checkfileedit = true;
            }
            this.getcurrentimage = item.master_images;
            this.previewimageedit = `${imagemasterPTUrl}/${item.masterpt_id}/${item.master_images}`;
            if (item.master_images == "" || item.master_images == null) {
              this.checkimageedit = false;
            } else {
              this.checkimageedit = true;
            }
          } catch (error) { }

          // load image //

          this.itemdata.date_of_application = this.formatDate(
            this.itemdata.date_of_application
          );

          this.date_of_application = this.parseDate(
            this.itemdata.date_of_application
          );
          this.itemdata.date_of_patent = this.formatDate(
            this.itemdata.date_of_patent
          );
          this.itemdata.date_of_publishing = this.formatDate(
            this.itemdata.date_of_publishing
          );
          this.itemdata.exam_request_date = this.formatDate(
            this.itemdata.exam_request_date
          );
          this.itemdata.exam_request_deadline = this.formatDate(
            this.itemdata.exam_request_deadline
          );
          this.itemdata.date_of_examination = this.formatDate(
            this.itemdata.date_of_examination
          );
          this.itemdata.next_deadline = this.formatDate(
            this.itemdata.next_deadline
          );
          this.itemdata.last_annuity_paid = this.formatDate(
            this.itemdata.last_annuity_paid
          );
          this.itemdata.next_annuity_date = this.formatDate(
            this.itemdata.next_annuity_date
          );
          this.itemdata.final_due_date_for_next_payment = this.formatDate(
            this.itemdata.final_due_date_for_next_payment
          );
          this.itemdata.next_renewal = this.formatDate(
            this.itemdata.next_renewal
          );
          this.itemdata.last_renewal_att = this.formatDate(
            this.itemdata.last_renewal_att
          );
          this.itemdata.international_filing_date = this.formatDate(
            this.itemdata.international_filing_date
          );
          this.sendBilling = this.itemdata.send_billing;
          this.sendBillingDetail = this.itemdata.send_billing_detail;

          this.customer_selected = this.itemdata.cus_billing_id;
          await this.onSelectComboboxMetterChange(this.customer_selected);

          if (this.itemdata.status == 6) {
            this.disabled_status = true;
          } else {
            this.disabled_status = false;
          }
          this.selectOwner(editItem[0].owner_contact);
          this.onSelectAgentChange(editItem[0].agent_contact);
          this.onSelectAssociateChange(editItem[0].associate_contact);
          this.loadAppointmentByfile_no(this.itemdata.file_no);
        } else {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "No Data",
            "text-h5 red--text text-center"
          );
          return;
        }
        if (
          this.itemdata.sub_type != "PARIS" &&
          this.itemdata.sub_type != "PCT" &&
          this.itemdata.sub_type != "" &&
          this.itemdata.sub_type
        ) {
          this.other_sub = this.itemdata.sub_type;
          this.itemdata.sub_type = "Other";
        }
      }

      this.timelineData = this.FlieArray;
    },

    async loaddataPriority() {
      const res_priority = await api.getAllMASTERPT_PRIORITY_BYID(
        Number(this.$route.params.masterpt_id)
      );
      if (res_priority.data.length > 0) {
        this.priorityList = [];
        this.priorityListOld = [];
        res_priority.data.forEach((item) => {
          this.priorityListOld.push(item.id);

          this.priorityList.push({
            id: item.id,
            number: item.priority_number,
            date:
              item.priority_date === "1970-01-01" ? null : item.priority_date,
            country: item.priority_country,
            menu: false,
          });
        });
      }
    },
    async loadAppointmentByfile_no(file_no) {
      this.mDataArrayappointment = [];
      const result = await api.getmasterptAllrecords({ file_no: file_no });
      if (result.data && result.data.length > 0) {
        result.data.forEach((x, i) => {
          this.mDataArrayappointment.push(x);
          x.show_status = "";
          if (x.cert && x.cert == 1) {
            if (x.show_status == "") {
              x.show_status = "Pending";
            }
          }
          if (x.report && x.report == 1) {
            if (x.show_status == "") {
              x.show_status = "Report";
            } else {
              x.show_status += " / Report";
            }
          }
          if (x.done && x.done == 1) {
            if (x.show_status == "") {
              x.show_status = "Complete";
            } else {
              x.show_status += " / Complete";
            }
          }
          const actions = this.safeParseArray(x.documenttype_actions);
          if (actions.length > 0) {
            x.documenttype_actions_showdata = actions
              .map((item) => item.name)
              .join(", ");
          }
        });
        if (
          !this.mDataArrayappointment[0].documenttype_code &&
          this.mDataArrayappointment.length == 1
        ) {
          this.mDataArrayappointment = [];
        }
      } else {
        this.disablebtnappointmentallrecord = true;
      }
    },
    async loaddataobjecttypeBygroupId() {
      const result = await api.getObjectTypeByGroupId(2);
      this.objecttype_list = result.data;
    },
    async loaddatacontactByContact_type_owner() {
      const result = await api.getContactByContactType(1);
      this.contact_owner_list = result.data;
    },
    async loaddatacontactByContact_type_agent() {
      const result = await api.getContactByContactType(2);
      this.contact_agent_list = result.data;
    },
    async loaddatacontactByContact_type_associate() {
      const result = await api.getContactByContactType(3);
      this.contact_associate_list = result.data;
    },
    async loaddatacountry() {
      const result = await api.getAllCountry();
      this.country_list = result.data;
    },

    async saveItem(mode) {
      if (this.itemdata.sub_type != "") {
        if (this.itemdata.sub_type == "Other") {
          this.itemdata.sub_type = this.other_sub;
        } else {
          this.itemdata.sub_type = this.itemdata.sub_type;
        }
      }
      if (this.itemdata.tm_type == 0) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Please Select Object Type",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (!this.itemdata.file_no) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Please Enter File No.",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (this.owner_contact_list.length == 0) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Please Enter Client Name",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (this.itemdata.sub_type != "" && this.itemdata.sub_type == "PCT") {
        if (this.itemdata.international_filing_number == "") {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "Please Enter International Filing Number",
            "text-h5 red--text text-center"
          );
          return;
        }
        if (!this.itemdata.international_filing_date) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "Please Enter International Filing Date",
            "text-h5 red--text text-center"
          );
          return;
        }
      }


      var contact_id = this.owner_contact_list
        .map((item) => item.contact_id)
        .join(",");
      this.itemdata.owner_contact = contact_id;

      if (this.mode_operation == "Update") {
        this.itemdata.date_of_application = this.changeformatDatetoinsert(
          this.itemdata.date_of_application
        );
        this.itemdata.date_of_patent = this.changeformatDatetoinsert(
          this.itemdata.date_of_patent
        );
        this.itemdata.date_of_publishing = this.changeformatDatetoinsert(
          this.itemdata.date_of_publishing
        );
        this.itemdata.exam_request_date = this.changeformatDatetoinsert(
          this.itemdata.exam_request_date
        );
        this.itemdata.exam_request_deadline = this.changeformatDatetoinsert(
          this.itemdata.exam_request_deadline
        );
        this.itemdata.date_of_examination = this.changeformatDatetoinsert(
          this.itemdata.date_of_examination
        );
        this.itemdata.next_deadline = this.changeformatDatetoinsert(
          this.itemdata.next_deadline
        );
        this.itemdata.last_annuity_paid = this.changeformatDatetoinsert(
          this.itemdata.last_annuity_paid
        );
        this.itemdata.next_annuity_date = this.changeformatDatetoinsert(
          this.itemdata.next_annuity_date
        );
        this.itemdata.final_due_date_for_next_payment =
          this.changeformatDatetoinsert(
            this.itemdata.final_due_date_for_next_payment
          );
        this.itemdata.next_renewal = this.changeformatDatetoinsert(
          this.itemdata.next_renewal
        );
        this.itemdata.last_renewal_att = this.changeformatDatetoinsert(
          this.itemdata.last_renewal_att
        );

        //   this.$showLoader();

        let formData = new FormData();
        formData.append("send_billing", this.sendBilling);
        if (this.sendBilling == "Reply All") {
          formData.append("send_billing_detail", "");
        } else {
          formData.append("send_billing_detail", this.sendBillingDetail);
        }
        if (this.getoldimage) {
          formData.append(`getoldimage`, this.getoldimage);
        } else {
          formData.append(`getcurrentimage`, this.getcurrentimage);
        }
        if (this.imageedit) {
          formData.append(`file`, this.imageedit);
        }

        this.image_listedit.forEach((x, index) => {
          formData.append(`file`, x);
        });

        if (
          this.getoldfilename &&
          this.getoldfilename != null &&
          this.getoldfilename != ""
        ) {
          formData.append("getoldfilename", this.getoldfilename);
        }

        if (
          this.getcurrentfilename &&
          this.getcurrentfilename != null &&
          this.getcurrentfilename != ""
        ) {
          formData.append("getcurrentfilename", this.getcurrentfilename);
        }

        formData.append("tm_type", this.itemdata.tm_type);
        formData.append("file_no", this.itemdata.file_no);
        formData.append("title", this.itemdata.title);

        const name_of_client = this.owner_contact_list
          .map((item) => item.contact_name)
          .join(", ");
        formData.append("name_of_client", name_of_client);

        formData.append("app_no", this.itemdata.app_no);
        formData.append("patent_no", this.itemdata.patent_no);
        formData.append("city", this.itemdata.city);

        if (this.itemdata.owner_contact) {
          formData.append("owner_contact", this.itemdata.owner_contact);
        }

        if (this.itemdata.agent_contact) {
          formData.append("agent_contact", this.itemdata.agent_contact);
        }

        if (this.itemdata.associate_contact) {
          formData.append("associate_contact", this.itemdata.associate_contact);
        }
        formData.append(
          "update_by",
          Number(localStorage.getItem(server.USER_ID))
        );
        formData.append("val_no", this.itemdata.val_no);
        formData.append("page_no", this.itemdata.page_no);
        formData.append("priority_number", this.itemdata.priority_number);
        formData.append("status", this.itemdata.status);
        formData.append("type", this.itemdata.type);
        formData.append("sub_type", this.itemdata.sub_type);

        if (this.itemdata.sub_type != "" && this.itemdata.sub_type == "PCT") {
          formData.append(
            "international_filing_number",
            this.itemdata.international_filing_number
          );
          formData.append(
            "international_filing_date",
            this.international_filing_date
          );
        } else {
          formData.append("international_filing_number", "");
          formData.append("international_filing_date", "");
        }
        formData.append("remark", this.itemdata.remark);
        formData.append(
          "dead_last_annuity_paid",
          this.itemdata.dead_last_annuity_paid
        );
        formData.append("client_ref", this.itemdata.client_ref);
        formData.append("good_service", this.itemdata.good_service);
        formData.append(
          "registration_condition",
          this.itemdata.registration_condition
        );
        formData.append("owner_address", this.itemdata.owner_address);
        formData.append("agent_address", this.itemdata.agent_address);
        formData.append("associate_address", this.itemdata.associate_address);
        if (this.itemdata.date_of_patent) {
          formData.append("date_of_patent", this.itemdata.date_of_patent);
        }
        if (this.itemdata.date_of_application) {
          formData.append(
            "date_of_application",
            this.itemdata.date_of_application
          );
        }

        if (this.itemdata.date_of_publishing) {
          formData.append(
            "date_of_publishing",
            this.itemdata.date_of_publishing
          );
        }

        if (this.itemdata.date_of_examination) {
          formData.append(
            "date_of_examination",
            this.itemdata.date_of_examination
          );
        }

        if (this.itemdata.next_renewal) {
          formData.append("next_renewal", this.itemdata.next_renewal);
        }

        if (this.itemdata.last_renewal_att) {
          formData.append("last_renewal_att", this.itemdata.last_renewal_att);
        }

        if (this.itemdata.next_deadline) {
          formData.append("next_deadline", this.itemdata.next_deadline);
        }

        if (this.itemdata.exam_request_deadline) {
          formData.append(
            "exam_request_deadline",
            this.itemdata.exam_request_deadline
          );
        }

        if (this.itemdata.exam_request_date) {
          formData.append("exam_request_date", this.itemdata.exam_request_date);
        }

        if (this.itemdata.next_annuity_date) {
          formData.append("next_annuity_date", this.itemdata.next_annuity_date);
        }
        if (this.itemdata.final_due_date_for_next_payment) {
          formData.append(
            "final_due_date_for_next_payment",
            this.itemdata.final_due_date_for_next_payment
          );
        }

        if (this.itemdata.last_annuity_paid) {
          formData.append("last_annuity_paid", this.itemdata.last_annuity_paid);
        }

        if (this.customer_selected) {
          formData.append("cus_billing_id", this.customer_selected);
        } else {
          formData.append("cus_billing_id", null);
        }
        this.$showLoader();
        const update_masterpt = await api.updateMasterPt_V2(
          this.main_id,
          formData
        );

        await api.AppointmentUpdateclientname(this.itemdata.file_no, {
          trademark_name: this.itemdata.name_of_client,
        });

        if (update_masterpt.status == 203) {
          this.$hideLoader();
          if (update_masterpt.data.file_no) {
            this.$store.state.global_dialog = true;
            this.setupAlertDialog(
              true,
              "data duplicate ",
              "please check File No.",
              "text-h5 red--text text-center"
            );
            return;
          }
          if (update_masterpt.data.app_no) {
            this.$store.state.global_dialog = true;
            this.setupAlertDialog(
              true,
              "data duplicate ",
              "please check Application No.",
              "text-h5 red--text text-center"
            );
            return;
          }
        }
        if (update_masterpt.status == 200 || update_masterpt.status == 201) {

          const removedFilesList = this.removed_cer_files || [];

          const existingFilesToKeep = this.filename_cer
            .filter(
              (f) =>
                f.checktypefile === "oldfile" &&
                !removedFilesList.includes(f.name)
            )
            .map((f) => f.name);

          const newFiles = this.image_list_cer.filter(
            (file) => !file.checktypefile || file.checktypefile === "newfile"
          );

          // สร้าง FormData
          var formDataCer = new FormData();

          newFiles.forEach((file) => {
            formDataCer.append("file", file); // ชื่อ 'file' ต้องตรงกับ multer config
          });

          const fileNames = newFiles.map((file) => file.name).join(",");
          formDataCer.append("file_cer", fileNames);
          formDataCer.append("removed_files", removedFilesList.join(","));

          const res = await api.update_cer_edit(this.main_id, formDataCer);

          if (this.itemdata.status == 6) {
            var res_clsed = await api.updateCloseApp(this.itemdata.file_no);
          }
          for (const [index, item] of this.priorityList.entries()) {
            if (item.id == 0) {
              var data_add_riority = {
                masterpt_id: this.main_id,
                priority_number: item.number,
                priority_date: item.date,
                priority_country: item.country,
              };

              if (item.number != "" || item.date != "" || item.country != "") {
                await api.createMASTERPT_PRIORITY(data_add_riority);
              }
            } else {
              var data_update_riority = {
                priority_number: item.number,
                priority_date: item.date,
                priority_country: item.country,
              };

              if (item.number != "" || item.date != "" || item.country != "") {
                await api.updateMASTERPTPRIORITY(item.id, data_update_riority);
              }
            }
          }
          if (this.priorityListOld.length > 0) {
            const notFoundIds = this.priorityListOld.filter(
              (id) => !this.priorityList.some((item) => item.id === id)
            );
            for (const [index, item] of notFoundIds.entries()) {
              await api.deleteMASTERPTPRIORITY(item);
            }
          }

          let dataAdd = {
            user_id: localStorage.getItem(server.USER_ID),
            log_in_out_id: localStorage.getItem(server.LOGIN_ID),
            action: "Create",
            table_name: "masterpt",
            table_id: this.main_id,
            date: moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
          };

          await api.addTransectionLog(dataAdd);

          var dataEditLog = {
            last_update: moment()
              .tz("Asia/Bangkok")
              .format("YYYY-MM-DD HH:mm:ss"),
          };
          await api.updateLogInOutLog(
            localStorage.getItem(server.LOGIN_ID),
            dataEditLog
          );

          this.$hideLoader();

          if (mode == "createAp") {
            this.$store.state.global_push_dialog = true;
            this.setupAlertDialogPush(
              true,
              "save data",
              "save data success",
              "text-h5 green--text text-center",
              `/appointment-patent-new/${this.itemdata.file_no}`
            );
          } else {
            this.$store.state.global_push_dialog = true;
            this.setupAlertDialogPush(
              true,
              "save data",
              "save data success",
              "text-h5 green--text text-center",
              "/master-patent-list"
            );
          }
        } else {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "save data",
            "can't save data",
            "text-h5 red--text text-center"
          );
        }
      }
      //this.$hideLoader();
    },

    selectOwner(id) {
      const idList = id.split(",").map((x) => x.trim());

      const foundList = this.contact_owner_list.filter((item) =>
        idList.includes(String(item.contact_id))
      );

      this.owner_contact_list = foundList;

      this.onSelectOwnerChange();
    },
    async onSelectOwnerChange() {
      if (this.owner_contact_list.length > 0) {
        for (const [index, item] of this.owner_contact_list.entries()) {
          item.owner_address =
            item.address + " " + item.city + " " + item.country;
        }
      }
      //alert(id);
      // this.contact_owner_list.filter((item) => {
      //   if (item.contact_id == id) {
      //     this.owner_address =
      //       item.address + " " + item.city + " " + item.country;
      //     return item;
      //   }
      // });
    },
    async onSelectAgentChange(id) {
      let setdata;
      setdata = this.contact_agent_list.filter((item) => {
        if (item.contact_id == id) {
          console.log(item);
          this.itemdata.agent_email = item.email;
          this.agent_address =
            item.address + " " + item.city + " " + item.country;
          return item;
        }
      });
    },
    async onSelectAssociateChange(id) {
      this.contact_associate_list.filter((item) => {
        if (item.contact_id == id) {
          this.associate_address =
            item.address + " " + item.city + " " + item.country;
          return item;
        }
      });
    },
    changeformatDatetoinsert(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month}-${day}`;
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day.padStart(2, "0")}/${month.padStart(2, "0")}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("/");
      return `${day.padStart(2, "0")}-${month.padStart(2, "0")}-${year}`;
    },

    async popuppreviewImageTable(filename) {
      const imageTab = window.open("");
      imageTab.document.write(`
        <html>
          <head>
            <title>Preview Image</title>
          </head>
          <body style="margin:0; display:flex; flex-direction:column; justify-content:center; align-items:center; height:100vh; background-color:#000;">
            <!-- แสดงภาพที่นี่ -->
            <img src="${imagemasterPTUrl}/${this.$route.params.masterpt_id}/${filename}" alt="Preview" style="max-width:100%; max-height:100%; margin-bottom:20px;" />
            
          </body>
        </html>
      `);
      return;
    },
    async popuppreviewfileTable(filename) {
      await this.openOldFile(
        `${filemasterPTUrl}/${this.$route.params.masterpt_id}/${filename}`
      );

      return;
    },
    async loadshowTimeline() {
      this.showtimelineData = [];
      this.$showLoader();

      const result = await api.gettimelinemasterpt({
        masterpt_id: this.$route.params.masterpt_id,
      });

      if (result.data && result.data.length > 0) {
        result.data.forEach((x, i) => {
          const isAnnuity = (x.documenttype_code || "").includes(
            "Annuity Fees"
          );

          if (isAnnuity) {
            x.show_date = `Last Annuity Payment - ${x.last_annuity} (Year)`;
            x.date_sort = x.last_annuity;
          } else if (x.documenttype_code === "New Filing") {
            x.show_date = `Application Date - ${x.application_date}`;
            x.date_sort = x.application_date;
          } else {
            x.show_date = `Submitted Date - ${x.submit_date}`;
            x.date_sort = x.submit_date;
          }

          this.showtimelineData.push(x);

          // parse JSON ก่อน แล้วเช็กว่ามีข้อมูลจริง
          let changeData = this.safeParseArray(x.change_master_record_data_All);

          if (changeData.length > 0) {
            x.documenttype_code =
              changeData.map((item) => item.field_name).join(" / ") || "";
          }
          this.showtimelineData.sort((a, b) => {
            const aIsAnnuity = (a.documenttype_code || "").includes(
              "Annuity Fees"
            );
            const bIsAnnuity = (b.documenttype_code || "").includes(
              "Annuity Fees"
            );

            // กลุ่ม if มาก่อน else
            if (aIsAnnuity && !bIsAnnuity) return -1;
            if (!aIsAnnuity && bIsAnnuity) return 1;

            // ถ้าอยู่ในกลุ่มเดียวกัน
            if (aIsAnnuity) {
              // เรียงตามตัวเลขมากไปน้อย
              return Number(b.date_sort) - Number(a.date_sort);
            } else {
              // แปลงวันที่ dd/mm/yyyy เป็น Date object แล้วเรียงมากไปน้อย
              const parseDate = (d) => {
                if (!d || typeof d !== "string") return new Date(0); // ถ้า null, undefined, หรือไม่ใช่ string ให้เป็นวันที่ต่ำสุด
                const parts = d.split("/");
                if (parts.length !== 3) return new Date(0); // ถ้ารูปแบบไม่ถูกต้อง
                const [day, month, year] = parts.map(Number);
                return new Date(year, month - 1, day);
              };
              return parseDate(b.date_sort) - parseDate(a.date_sort);
            }
          });
          // this.showtimelineData
        });
        if (
          !this.showtimelineData[0].documenttype_code &&
          this.showtimelineData.length == 1
        ) {
          this.showtimelineData = [];
        }
      }
      this.$hideLoader();
    },
    setupAlertDialogPush(status, title, message, text_color, link) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
      this.link = link;
    },
    setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
    async openhideshowlistofrecord() {
      this.hideshowlistofrecord = !this.hideshowlistofrecord;
    },
    async openhideshowtimeline() {
      this.disablebtnappointmenttimeline = !this.disablebtnappointmenttimeline;
    },
    async openeditItemAppointment(appointment_id) {
      window.open(`/appointment-patent-edit/${appointment_id}`);
    },
  },
  beforeCreate() {
    this.$store.state.navMenu = true;
  },

  watch: {
    show: function (s) {
      if (s) {
        this.getPdf();
      }
    },
    page: function (p) {
      if (
        window.pageYOffset <= this.findPos(document.getElementById(p)) ||
        (document.getElementById(p + 1) &&
          window.pageYOffset >= this.findPos(document.getElementById(p + 1)))
      ) {
        // window.scrollTo(0,this.findPos(document.getElementById(p)));
        document.getElementById(p).scrollIntoView();
      }
    },
  },
  watch: {
    international_filing_date(val) {
      this.itemdata.international_filing_date = this.formatDate(
        this.international_filing_date
      );
    },
    date_of_application(val) {
      this.itemdata.date_of_application = this.formatDate(
        this.date_of_application
      );
    },
    date_of_patent(val) {
      this.itemdata.date_of_patent = this.formatDate(this.date_of_patent);
    },
    date_of_publishing(val) {
      this.itemdata.date_of_publishing = this.formatDate(
        this.date_of_publishing
      );
    },
    exam_request_date(val) {
      this.itemdata.exam_request_date = this.formatDate(this.exam_request_date);
    },
    exam_request_deadline(val) {
      this.itemdata.exam_request_deadline = this.formatDate(
        this.exam_request_deadline
      );
    },
    date_of_examination(val) {
      this.itemdata.date_of_examination = this.formatDate(
        this.date_of_examination
      );
    },
    next_deadline(val) {
      this.itemdata.next_deadline = this.formatDate(this.next_deadline);
    },
    last_annuity_paid(val) {
      this.itemdata.last_annuity_paid = this.formatDate(this.last_annuity_paid);
    },
    next_annuity_date(val) {
      this.itemdata.next_annuity_date = this.formatDate(this.next_annuity_date);
    },
    final_due_date_for_next_payment(val) {
      this.itemdata.final_due_date_for_next_payment = this.formatDate(
        this.final_due_date_for_next_payment
      );
    },
    next_renewal(val) {
      this.itemdata.next_renewal = this.formatDate(this.next_renewal);
    },
    last_renewal_att(val) {
      this.itemdata.last_renewal_att = this.formatDate(this.last_renewal_att);
    },
  },
};
